<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<vxe-grid ref="orderdetail" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			data: {
				default: () => {
					return null
				}
			},
			type: {
				default: () => {
					return 'unpay'
				}
			}
		},
		data() {
			return {
				modal_title: '采购单详情',
				modal_width: 1200,
				modal_height: 600,
				list_autorender: false,
				list_footerField: [{
					field: 'size',
					toFixed: 0
				}, {
					field: 'totalweight',
					toFixed: 4
				}],
				orderdata: [],
				currentrow: null,
				columns: [],
				toolbarButton: []
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			modal_init() {
				let list_columns = [{
					type: 'seq',
					field: '',
					title: '',
					width: 50,
				}, {
					field: 'billCode',
					title: '单据编码',
				}, {
					field: 'supplierName',
					title: '供应商',
				}, {
					field: 'storageName',
					title: '仓库'
				}, {
					field: 'salesManName',
					title: '业务员'
				}, {
					field: 'skuCode',
					title: '产品编码'
				}, {
					field: 'size',
					title: '数量'
				}, {
					field: 'totalweight',
					title: '重量'
				}, {
					field: 'boxgauge',
					title: '盒规'
				}, {
					field: 'bingauge',
					title: '箱规'
				}, {
					field: 'reportTime',
					title: '报货时间'
				}, {
					field: 'pregettime',
					title: '预计到货时间'
				}, {
					field: 'status',
					title: '状态',
					type: '',
					formatter: ({
						row
					}) => {
						let selectoptions = {
							1:'未到货',
							2:'部分到货',
							3:'完成',
							4:'关闭',
							5:'待提交',
							6:'审核中',
							7:'退单失败',
							8:'已拒绝'
						}	
						return selectoptions[row.status]
					}
				}]
				let list_toolbarButton = [{
					code: 'export',
					name: '导出',
					status: "success"
				}]
				this.columns = list_columns
				this.toolbarButton = list_toolbarButton
				this.list_init()

			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.columns = this.columns
				gridOptions.toolbarConfig.buttons = this.toolbarButton
				gridOptions.formConfig = false
			},
			list() {
				return new Promise((resolve) => {
					resolve({
						list: this.data.data
					})
				})
			}
		},
		components: {

		}
	}
</script>